export enum PointExchangesEndpoints {
  POINT_EXCHANGES = "point-exchanges",
  CREATE_PAYMENT_LINK = "point-exchanges/:id/create-payment-link",
  PAYMENT_HISTORY_DETAIL = "payment-histories/:paymentId",
  PAYMENT_HISTORY_DETAIL_PAYPAL = "payment-histories/:paymentId/payment/paypal",
  PAYMENT_BANK_TRANSFER_CREATE = "point-exchanges/:pointExchangeId/create-payment-bank-transfer",
  PAYMENT_HISTORY_EDIT = "payment-histories/:paymentId",
}
